import { Dispatch, SetStateAction } from 'react';

import { StatusFigurant } from 'models';
import { Button } from 'components';
import { Alert, FigurantSelected, Header } from './components';

import { TYPES_ACTION } from './@types';
import { useSelectedFigurantsModal } from './useSelectedFigurantsModal';
import * as S from './styles';

type Props = {
  currentStep?: number;
  totalFigurant?: number;
  selectedFigurant: StatusFigurant[];
  setSelectedFigurant: Dispatch<SetStateAction<StatusFigurant[]>>;
  typeAction: TYPES_ACTION;
  handleNext: () => void;
  type?: string;
  hasMissingFigurant?: boolean;
};

export const SelectedFigurantsModal = ({
  currentStep,
  totalFigurant = 0,
  selectedFigurant,
  setSelectedFigurant,
  typeAction,
  handleNext,
  type = '1',
  hasMissingFigurant,
}: Props) => {
  const { ExpandIcon, open, onClickNext, removeFigurant, showAlert, showAlertOpened, textAction, toggleDrawer } =
    useSelectedFigurantsModal({
      selectedFigurant,
      setSelectedFigurant,
      typeAction,
      currentStep,
      handleNext,
      hasMissingFigurant,
      totalFigurant,
      type,
    });

  return (
    <S.Drawer $open={open}>
      <S.Container>
        <Header
          ExpandIcon={ExpandIcon}
          selectedFigurant={selectedFigurant}
          textAction={textAction}
          toggleDrawer={toggleDrawer}
          totalFigurant={totalFigurant}
          type={type}
        />
        {showAlert[typeAction] && (
          <Alert
            typeAction={typeAction}
            totalFigurant={totalFigurant}
            totalFigurantsSelected={selectedFigurant?.length}
            type={type}
          />
        )}
        {open && (
          <>
            <S.FigurantList>
              {selectedFigurant?.map(item => (
                <FigurantSelected key={item?.id} item={item} removeFigurant={removeFigurant} type={type} />
              ))}
              {showAlertOpened[typeAction] && (
                <Alert
                  typeAction={typeAction}
                  totalFigurant={totalFigurant}
                  totalFigurantsSelected={selectedFigurant?.length}
                  type={type}
                />
              )}
            </S.FigurantList>
            {selectedFigurant?.length !== totalFigurant && typeAction === TYPES_ACTION.CLIMBED && (
              <Button variant="outlined" sx={{ my: 2 }} onClick={toggleDrawer} width="100%">
                Escalar Figurante
              </Button>
            )}
          </>
        )}
        <Button width="100%" variant="contained" onClick={onClickNext}>
          Próximo
        </Button>
      </S.Container>
    </S.Drawer>
  );
};
